import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import DashboardLayout from "../../layout/DashboardLayout";
import ProtectedRoute from "../../Components/ProtectedRoute";
import { ROLES, getDashboardHomePath } from "../../utils/roles";
import DashboardApplications from "./DashboardApplications";
import DashboardApplicationForm from "./DashboardApplicationForm";
import DashboardGestori from "./DashboardGestori";
import DashboardGestoreEvents from "./DashboardGestoreEvents";
import DashboardEndEvents from "./DashboardEndEvents";
import DashboardStartEvents from "./DashboardStartEvents";
import DashboardIscrizioni from "./DashboardIscrizioni";
import DashboardUsers from "./DashboardUsers";
import DashboardProfile from "./DashboardProfile";
import DashboardPolls from "./DashboardPolls";
import DashboardEventChats from "./DashboardEventChats";
import CreateUser from "../createUser";

const DashboardShell = ({ loginStatus, setLoginStatus, children, minRole, exactRole, allowedRoles }) => (
  <ProtectedRoute
    loginStatus={loginStatus}
    minRole={minRole}
    exactRole={exactRole}
    allowedRoles={allowedRoles}
  >
    <DashboardLayout loginStatus={loginStatus} setLoginStatus={setLoginStatus}>{children}</DashboardLayout>
  </ProtectedRoute>
);

const DashboardRoutes = ({ loginStatus, setLoginStatus }) => (
  <Switch>
    <Route
      exact
      path="/dashboard"
      render={() => (
        <ProtectedRoute loginStatus={loginStatus}>
          <Redirect to={getDashboardHomePath(loginStatus)} />
        </ProtectedRoute>
      )}
    />
    <Route
      exact
      path="/dashboard/applicazioni"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.ADMIN]}>
          <DashboardApplications />
        </DashboardShell>
      )}
    />
    <Route
      exact
      path="/dashboard/applicazioni/nuova"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.ADMIN]}>
          <DashboardApplicationForm isNew />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/applicazioni/:id"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.ADMIN]}>
          <DashboardApplicationForm />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/gestori"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.ADMIN]}>
          <DashboardGestori />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/eventi"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.GESTORE]}>
          <DashboardGestoreEvents loginStatus={loginStatus} />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/inizia-eventi"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.GESTORE]}>
          <DashboardStartEvents />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/termina-eventi"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.GESTORE]}>
          <DashboardEndEvents />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/sondaggi"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.GESTORE]}>
          <DashboardPolls />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/chat-evento"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.GESTORE]}>
          <DashboardEventChats />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/iscrizioni"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.GESTORE]}>
          <DashboardIscrizioni />
        </DashboardShell>
      )}
    />
    <Route
      exact
      path="/dashboard/utenti/nuovo"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.ADMIN]}>
          <CreateUser adminMode embedded />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/utenti"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.ADMIN]}>
          <DashboardUsers loginStatus={loginStatus} />
        </DashboardShell>
      )}
    />
    <Route
      path="/dashboard/profilo"
      render={() => (
        <DashboardShell loginStatus={loginStatus} setLoginStatus={setLoginStatus} allowedRoles={[ROLES.ADMIN, ROLES.GESTORE]}>
          <DashboardProfile loginStatus={loginStatus} setLoginStatus={setLoginStatus} />
        </DashboardShell>
      )}
    />
    <Route
      render={() => (
        <ProtectedRoute loginStatus={loginStatus}>
          <Redirect to={getDashboardHomePath(loginStatus)} />
        </ProtectedRoute>
      )}
    />
  </Switch>
);

export default DashboardRoutes;
